
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

import Modules from './Modules.vue';

import { AcademicYear, Course } from '../models/grade-viewmodels';
import { Config } from '../models/config-viewmodel';
import { Message } from '@/shared/models/view/message-viewmodel';

import GradeService from '../services/grade-service';
import HttpService from '@/shared/services/http-service';


@Component({
    computed: {
        ...mapState(['activeStudy', 'config']),
        ...mapGetters('root', ['label'])
    },
    components: {
        Modules
    }
})
export default class AcademicYearComponent extends Vue {
    @Prop() year!: AcademicYear;
    @Prop() id!: string;
    @Prop() title!: string;
    
    public loading = false;
    public dataLoaded = false;
    private labelModule = 'ModuleOverview';

    public config!: Config;

    private toggleOpen(): void {
        this.year.isOpen = !this.year.isOpen;
        
        if (!this.dataLoaded) {
            this.loading = true;
            this.loadData()
            this.dataLoaded = true;
        }
    }

    get barTitle() {
        return `${this.title ? this.title + ' ' : ''}${this.year.year} - ${this.year.year + 1}`
    }

    private loadData() {
      Promise.all([
        GradeService.getAllCoursesByStudy(this.config.language, this.config.vuNetIdStudent, this.year.year, this.id, HttpService),
        ])
        .then(values => {
            this.loading = false;
          
            this.$store.commit('setCoursesByStudy', {values: values[0], year: this.year.year, studyId: this.id});
            this.year.loaded = true;
        })
        .catch(error => {
            console.error(error);
            this.$store.commit('root/setMessage', new Message('ModuleOverview', 'Er is iets fout gegaan bij het ophalen van de resultaten: ' + error));
            this.loading = false;
        })
    }

    updated() {
        if (!this.year.loaded && this.year && this.year.isOpen) {
            this.loadData();
        }
    }
}
